import React, { FC, useEffect, useState } from 'react'
import './index.scss'

// props
interface IProps {
  name: string;
  choosedName?: string; // 头部提示语
  isShow: boolean; // 是否默认展开
  onClick: () => void; // 展开可选项
  children: React.ReactNode;
  isWrong?: boolean;
  modifiers?: any;
}

const SingleChoose: FC<IProps> = ({ name, choosedName, isShow, onClick, children, isWrong, modifiers }) => {
  const [disabledName, setDisabledName] = useState(modifiers && modifiers?.modifiers?.length > 9)

  const handleClick = () => {
    setDisabledName(false)
  }

  useEffect(() => {
    modifiers && setDisabledName(modifiers?.modifiers?.length > 9)
  }, [modifiers])

  return (
    <section className={`single-choose-element${isShow ? ' show' : ''}${isWrong ? ' wrong' : ''}`}>
      <div className='title' data-cypid={`single-choose-element_${name}`} onClick={() => onClick()}>
        <span>{name}</span>
        <span>{choosedName}</span>
      </div>
      {disabledName ? (
        <div className='to-choose-tip' data-cypid={`to-choose-tip_${name}`} onClick={handleClick}>
          <div className='selected-list'>
            <i className='iconfont icon-a-shenglvehao1'></i>
          </div>
          <i className='iconfont icon-chevron-right'>
          </i>
        </div>
      ) : ''}
      <div style={{ 'display': (disabledName ? 'none' : 'block') }}>
        <div className='select-list'>
          {children}
        </div>
      </div>

    </section>
  )
}

export default SingleChoose
